import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EarningsFormatterPipe } from './earnings-formatter.pipe';



@NgModule({
  declarations: [EarningsFormatterPipe],
  imports: [
    CommonModule
  ],
  exports: [EarningsFormatterPipe]
})
export class EarningsFormatterModule { }
